/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./EnStripe.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuEn from "../../assets/component/HomepageMenuEn/HomepageMenuEn.js";

class EnStripe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="EnStripe-view">
        <Helmet>
          <title>Stripe - CheckPlus</title>
        </Helmet>
        {renderHomePageHeader(this)}
        {!!this.state.showModal && (
          <HomepageMenuEn closeModal={this.closeModal} />
        )}
        <div className="EnStripe-section">
          <div className="EnStripe-partnerwithstripe" />
        </div>

        <div className="EnStripe-section2">
          <div className="EnStripe-heading EnStripe-firstTxt">
            We have teamed up with Stripe to securely process all card payments.
          </div>
          <div className="EnStripe-cardContainer">
            <div className="EnStripe-visaIcon" />
            <div className="EnStripe-mastercardIcon" />
            <div className="EnStripe-amexIcon" />
            <div className="EnStripe-unionpayIcon" />
            <div className="EnStripe-applePay" />
            <div className="EnStripe-googlePay" />
          </div>
        </div>

        <div className="EnStripe-section3">
          <div className="EnStripe-featuresContainer">
            <div className="EnStripe-aes">AES-256</div>
            <div className="EnStripe-txt">
              All card numbers are encrypted with AES-256, the same technology
              is also used by major banks and governments across the world.
            </div>
          </div>
          <div className="EnStripe-featuresContainer">
            <div className="EnStripe-pci" />
            <div className="EnStripe-txt">
              Stripe is a PCI certified payment gateway, so you can rest assured
              your data is in safe hands.
            </div>
          </div>
        </div>

        <div className="EnStripe-section4">
          <div className="EnStripe-heading EnStripe-text4">
            Do I need to sign up a separate Stripe account?
          </div>

          <div className="EnStripe-notepadContainer">
            <div className="EnStripe-notepad" />
          </div>
          <div className="EnStripe-txt EnStripe-description4">
            No, when you sign up for CheckPlus, our system automatically sets up
            a Stripe account on our end. Therefore, you will only need to manage
            one dashboard for all payments.
          </div>
        </div>

        <div className="EnStripe-section5">
          <div className="EnStripe-logo" />
          <div className="EnStripe-txt EnStripe-description5">
            Get started with CheckPlus with Stripe Integration
          </div>
          <Link to="/OrgLogin">
            <div className="EnStripe-first-bar">Sign Up Now</div>
          </Link>
        </div>

        <div className="EnStripe-footer">
          <div className="EnStripe-footerNav">
            <Link to="/EnTeam">
              <div className="EnStripe-footerNavItem">Our Founders</div>
            </Link>
            <Link to="/EnFaq">
              <div className="EnStripe-footerNavItem">FAQ</div>
            </Link>
            <Link to="/EnContact">
              <div className="EnStripe-footerNavItem">Contact Us</div>
            </Link>

            <Link to="/EnPrivacyPolicy">
              <div className="EnStripe-footerNavItem">Privacy Policy</div>
            </Link>

            <Link to="/EnTerms">
              <div className="En-footerNavItem">Terms and Conditions</div>
            </Link>
          </div>

          <div className="EnStripe-footer_text">
            Flat A, 5/F, Wah Lee Industrial Building
            <br />
            11 Sze Shan Street, Yau Tong, Kowloon, Hong Kong
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. All Rights Reserved.
          </div>
        </div>
      </div>
    );
  }
}

export default EnStripe;
